"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatVersion = 1;
exports.ChatEventCategory = "Chat";
exports.ChatCommandCategory = "Chat";
//# sourceMappingURL=ChatDefinition.js.map